export default "__VITE_PUBLIC_ASSET__dc348556__"